<div class="page-container">
  <div class="page-heading">
    <h3>
      <img src="assets/icons/person_black_24dp.svg">
      <span class="page-title">{{'basic.plannerManagement' | translate}}</span>
    </h3>
  </div>
  <div class="page-content">
    <div class="card">
      <div class="card-body">
        <div>
          <div class="row">
            <div class="col-4 form-group max-content">
              <label class="gray-text">{{'planners.search' | translate}}</label><br>
              <input type="text" [(ngModel)]="searchInput" placeholder="{{'basic.name' | translate}}" class="form-control">
            </div>
            @if (isSuperuser) {
              <div class="col-8 form-group text-right">
                <button class="btn btn-primary text-white mt-4" id="newPlanner" data-bs-toggle="modal" data-bs-target="#plannerModal">+ {{'planners.newPlanner' | translate}}</button>
              </div>
            }
          </div>
          <div class="row">
            <table class="mt-5 min-width">
              <thead>
                <tr>
                  <th role="button" scope="col" [appSort]="planners" data-order="desc" data-name="name" class="col-3 gray-text font-weight-normal min-width">
                    <span>{{'planners.nameAndUsername' | translate}}</span>
                    <img src="assets/icons/unfold_more_gray_24dp.svg">
                  </th>
                  <th scope="col" class="col-2 gray-text font-weight-normal min-width"></th>
                  <th scope="col" class="col-3 gray-text font-weight-normal min-width">{{'basic.projects' | translate}}</th>
                </tr>
              </thead>
              @if (planners.length > 0) {
                <tbody class="min-width">
                  @for (item of planners | searchFilter: searchInput; track $index; let i = $index) {
                    <tr  class="border-bottom border-top border-gray">
                      <td class="col-3">
                        <input type="checkbox" #checkboxes class="projectchecker" value="{{item.id}}" name="projectchecker" (change)="onChange(item.id)" style="margin-top: 8px;">
                        <a href='#' class="" (click)="goToPlannerDetail($event, item.id)">
                          <div class="bold-text black-text col-10">
                            @if (!item.disabled) {
                              <img src="assets/icons/active.svg">
                            }
                            @if (item.disabled) {
                              <img src="assets/icons/not_active.svg">
                            }
                            {{item.name}}
                            @if (item.email) {
                              <div class="gray-text font-weight-normal" style="font-size: 0.85em; padding-left: 40px;">{{item.email}}</div>
                            }
                          </div>
                        </a>
                      </td>
                      <td class="col-2">
                        @if (item.role === 4) {
                          <span class="badge bg-primary">{{'planners.superuser' | translate}}</span>
                        }
                      </td>
                      <td class="col-3">
                        <div class="same-line">
                          @for (project of item.projects; track $index) {
                            <div class="gap-between-elements text-align-center gray-text rounded-pill px-2">{{project}}</div>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              }
              @if (planners.length == 0) {
                <tbody class="min-width">
                  <tr>
                    @if (loading) {
                      <td>{{'basic.loading' | translate}}</td>
                    }
                    @if (!loading) {
                      <td>{{'planners.noPlanners' | translate}}</td>
                    }
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              }
            </table>
            @if (projects.length>0) {
              <div class="mt-4">
                <div class="mb-2">{{'planners.addProject' | translate}}</div>
                <select #projectselect (change)="onSelected(projectselect.value)" class="mb-2">
                  <option>-{{'planners.selectProject' | translate}}-</option>
                  @for (item of projects; track $index) {
                    <option value="{{item.id}}">{{item.name}} {{item.id == currentProjectId ? ('planners.currentProject' | translate) : '' }}</option>
                  }
                </select>
                <br>
                  <button (click)="addProject()" class="btn btn-primary col-3 mt-2">{{'planners.add' | translate}}</button>
                </div>
              }
            </div>
            <!-- Modal -->
            <div class="modal fade" id="plannerModal" tabindex="-1" aria-labelledby="plannerModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-body padding-modal">
                    <img src="assets/icons/person_black_24dp.svg" class="top-position-image">
                    <span class="title ms-2">{{'planners.newPlanner' | translate}}</span>
                    <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                    <form ngNativeValidate (ngSubmit)="addNewPlanner()">

                      <div class="form-group mt-3 row">
                        <div class="col-6">
                          <label class="gray-text"><span class="mt-1">*</span>{{'basic.firstName' | translate}}</label><br>
                          <input type="text" [(ngModel)]="firstName" [ngModelOptions]="{standalone: true}" class="form-control " required>
                        </div>
                        <div class="col-6">
                          <label class="gray-text"><span class="mt-1">*</span>{{'basic.lastName' | translate}}</label><br>
                          <input type="text" [(ngModel)]="lastName" [ngModelOptions]="{standalone: true}" class="form-control" required>
                        </div>

                      </div>
                      <div class="mt-3 row form-group">
                        <div class="col-6">
                          <div class="gray-text form-group">
                            <label><span class="mt-1">*</span>{{'basic.email' | translate}}</label><br>
                            <input type="email"  [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="form-control" required>
                          </div>
                        </div>
                        <div class="col-6">
                        </div>
                      </div>
                      <hr>
                        <div class="mt-3 row form-group">
                          <div class="col-6">
                            <div class="gray-text form-group">
                              <label><span class="mt-1">*</span>{{'basic.username' | translate}}</label><br>
                              <input type="text"  [(ngModel)]="username" [ngModelOptions]="{standalone: true}" class="form-control" required>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 row form-group">
                          <div class="col-6">
                            <div class="gray-text form-group">
                              <label><span class="mt-1">*</span>{{'basic.password' | translate}}</label><br>
                              <input type="password"  [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="form-control" required>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="gray-text form-group">
                              <label><span class="mt-1">*</span>{{'basic.passwordAgain' | translate}}</label><br>
                              <input type="password"  [(ngModel)]="password2" [ngModelOptions]="{standalone: true}" class="form-control" required>
                              <span [hidden]="password == password2" class="red-text">{{'basic.passwordsDontMatch' | translate}}</span>
                            </div>
                          </div>
                        </div>
                        <hr>
                          @if (customerId === customerIds.POWERLINES) {
                            <div class="mt-3 form-group row">
                              <div class="col-6">
                                <app-checkbox
                                  [text]="'planners.createSuperuser' | translate"
                                  [checkbox]="newPlannerSuperuser"
                                  (isChecked)="newPlannerSuperuser = !newPlannerSuperuser">
                                </app-checkbox>
                              </div>
                            </div>
                            <hr>
                          }
                          <div class="mt-3 form-group row">
                            <div class="col-6">
                              <p class="gray-text">{{'basic.projects' | translate}}</p>
                              <select class="form-select" (change)="selectProject($event.target.value)">
                                <option [value]="">{{'planners.selectProjects' | translate}}</option>
                                @for (project of unselectedProjects; track $index) {
                                  <option [value]="project.id">{{project.name}} {{project.id == currentProjectId ? ('planners.currentProject' | translate) : '' }}</option>
                                }
                              </select>

                              <div class="same-line mt-3">
                                @for (project of selectedProjects; track $index) {
                                  <div  (click)="unselectProject(project.id)" style="cursor: pointer;" class="gap-between-elements text-align-center gray-text rounded-pill px-2">{{project.name}}</div>
                                }
                              </div>
                            </div>
                          </div>
                          <hr>
                            <div class="mt-3 form-group row">
                              <div class="col-6">
                                <p class="gray-text">{{'basic.interfaceLanguage' | translate}}</p>
                                <select class="form-select" (change)="languageChange($event.target.value)">
                                  @for (language of interfaceLanguages; track $index) {
                                    <option [value]="language.databaseLanguage">{{language.displayName}}</option>
                                  }
                                </select>
                              </div>
                            </div>
                            <hr>
                              <div class="mt-5">
                                <button type="submit" id="modalSaveButton" class="btn btn-primary col-3">{{'basic.save' | translate}}</button>
                                <button type="button" id="modalClose" class="btn btn-secondary ms-3 col-3" data-bs-dismiss="modal">{{'basic.cancel' | translate}}</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>



